import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { debounce } from 'lodash';
import React from "react";
import Select from 'react-select';
import WebServices from '../../WebServices';


const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 250,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
  },
  chip: {
    margin: '18px',
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  },
});



const inputComponent = ({ inputRef, ...props }) => <div ref={inputRef} {...props} />;

const NoOptionsMessage = props =>
  (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );


const Option = props => {

  let project = JSON.parse(props.children);
  return (
    <ListItem
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      <ListItemText primary={project.name} secondary={project.gbu} />
    </ListItem>
  )
};

const Placeholder = props =>
  (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );


const SingleValue = props =>
  (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  );


const ValueContainer = props => {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}


const Menu = (props) => (
  <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
    {props.children}
  </Paper>
);

const Control = (props) =>
  (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );

const Tooltip = (props) => (
  <Tooltip content="Search projects">
    <components.NoOptionsMessage {...props} />
  </Tooltip>
)

const components = {
  Tooltip,
  Control,
  Menu,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

class ProjectLookupSelect extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      projects: [],
      filteredProjects: [],
      searchTerm: '',
      selectedProject: null,
      loading: false,
      loadingError : false
    }

    this.webServices = new WebServices();
  }

  componentDidMount()
  {
      this.updateOptions();
  }
  updateOptions() {
    this.setState({ loading: true });
    this.webServices.getJADBProjects(this.state.searchTerm)
      .then((projects) => {
        
          this.setState({ projects,loading:false })
          this.filterProjects();
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false,loadingError:true });
      });
  }

  filterProjects()
  {
      if (this.state.searchTerm) {
          this.setState({filteredProjects:[...this.state.projects]});
      } else {
          const filteredProjects = this.state.projects.filter( project => project.name.includes(this.state.searchTerm));
          this.setState(filteredProjects);
      }
  }
  clearSearch() {
    this.setState({ filterProjects: [...this.state.projects], searchTerm: '' })
  }

  render() {
    let usersJson = this.state.projects.map(project => {
      let json = JSON.stringify(project);
      return { label: json }
    });

    const { classes, theme } = this.props;
    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
        },
      }),
    };

    const updateOptions = debounce((searchTerm) => {
      this.updateOptions(searchTerm);
    }, 300);

    return (

      <div className="form-field-padding">
        <Grid container>
          <Grid item xs={8}>
            <Select
              inputValue={this.state.searchTerm}
              classes={classes}
              styles={selectStyles}
              options={usersJson}
              components={components}
              value={this.state.selectedUser}
              onChange={(projectLookupJson) => {
                try{
                  let project = projectLookupJson ? JSON.parse(projectLookupJson.label) : null;
                  this.props.onProjectSelected(project);
                }catch(error) {
                }
              }}
              placeholder="Search Projects"
              onInputChange={(searchTerm) => {
                if (!searchTerm) {
                  this.clearSearch();
                } else {
                  this.setState({ searchTerm })
                  updateOptions(searchTerm)
                }
              }}
            />
          </Grid>
          <Grid item xs={1}>
            {this.state.loading && <CircularProgress className={classes.progress} size={20} />}
          </Grid>
        </Grid>
      </div>
    );
  }
}



export default withStyles(styles, { withTheme: true })(ProjectLookupSelect);
